import { MobileCarouselTabs } from 'lib/mobileDesignSystem';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { FACTORING_DEFAULT_TAB, FACTORING_TABS } from './tabConfig';

const FactoringTabsView: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('f_tab') ?? FACTORING_DEFAULT_TAB;

  const handleChange = (value: string) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set('f_tab', value);
        return next;
      },
      { replace: true },
    );
  };

  return (
    <MobileCarouselTabs
      items={FACTORING_TABS}
      value={activeTab}
      onChange={handleChange}
    />
  );
};

export default FactoringTabsView;
